module.exports = __webpack_public_path__ + "img/horizontal_7_5_3016.bc0e3050.png";